import styled from 'styled-components';
import Overlay from 'ggApp/shared/common/Overlay';

const Background = styled(Overlay)`
    z-index: 5;
`;

export default Background;